import { builderAuthHeader } from '../../common/utils/auth';
import {
  HOME_CLIENT_DETAILS_BEGIN,
  HOME_CLIENT_DETAILS_SUCCESS,
  HOME_CLIENT_DETAILS_FAILURE,
  HOME_CLIENT_DETAILS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function clientDetails(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_CLIENT_DETAILS_BEGIN,
    });
    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}clients/details/`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_CLIENT_DETAILS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_CLIENT_DETAILS_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('error>>>>>clientDetails', err);
        },
      );
    });

    return promise;
  };
}

export function dismissClientDetailsError() {
  return {
    type: HOME_CLIENT_DETAILS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CLIENT_DETAILS_BEGIN:
      return {
        ...state,
        clientDetailsPending: true,
        clientDetailsError: null,
      };

    case HOME_CLIENT_DETAILS_SUCCESS:
      return {
        ...state,
        clientDetailsPending: false,
        clientDetailsError: null,
        clientDetail: action.data,
      };

    case HOME_CLIENT_DETAILS_FAILURE:
      return {
        ...state,
        clientDetailsPending: false,
        clientDetailsError: action.data.error,
      };

    case HOME_CLIENT_DETAILS_DISMISS_ERROR:
      return {
        ...state,
        clientDetailsError: null,
      };

    default:
      return state;
  }
}
